import Edicao from './Edicao'
import Orgao from './Orgao'
import CategoriaAto from './CategoriaAto'
import Documento from './Documento'

class Ato {
    constructor(
        {
            id = null,  
            titulo_ato = null,  
            edicao_id = null,  
            orgao_id = null,  
            categoria_ato_id = null, 
            conteudo_html = null, 
            ato_documento_id = null, 
            dt_criacao = null,  
            dt_atualizacao = null, 
            anexos_count = null,
            publicacao = null,

            edicao = {},
            orgao = {},
            categoria = {},
            documento_ato = {},            
            
        } = {}
    ) {
        this.id = id;  
        this.titulo_ato = titulo_ato;  
        this.edicao_id = edicao_id;
        this.orgao_id = orgao_id; 
        this.categoria_ato_id = categoria_ato_id; 
        this.conteudo_html = conteudo_html; 
        this.ato_documento_id = ato_documento_id; 
        this.dt_criacao = dt_criacao;  
        this.dt_atualizacao = dt_atualizacao; 
        this.anexos_count = anexos_count; 
        this.publicacao = publicacao; 

        this.edicao = edicao ? new Edicao(edicao) : new Edicao();  
        this.orgao = orgao ? new Orgao(orgao) : new Orgao();  
        this.categoria = categoria ? new CategoriaAto(categoria) : new CategoriaAto();  
        this.documento_ato = documento_ato ? new Documento(documento_ato) : new Documento();           
    }
}

export default Ato;